module.exports = __webpack_public_path__ + "static/media/6.c2e6ff0a.PNG";